import { TrashSimple } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { usePartFinderAttributeActions } from 'companySettings/hooks';
import { IPartFinderAttribute } from 'companySettings/types';
import { Button, Confirmation } from 'core/components';
import { NotificationPosition } from 'core/enums';
import { useAgGridClientTableContext } from 'core/states';
import { Color, Variant } from 'theme/enums';

// Removing is never blocked; the warning says what happens to the lists wherever they are used.
export const RemovePartFinderAttributesButton = () => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, updateRows } = useAgGridClientTableContext();
  const { removePartFinderAttributes } = usePartFinderAttributeActions(NotificationPosition.TOP);

  const attributes = (selectedRows ?? []) as IPartFinderAttribute[];

  const onRemove = async () => {
    setIsConfirmationOpen(false);

    const { success } = await removePartFinderAttributes(
      attributes.map((attribute) => attribute.id)
    );

    if (!success) {
      return;
    }

    updateRows({ remove: attributes });
  };

  return (
    <>
      <Button
        text={t('buttonLabelRemove')}
        variant={Variant.SOFT}
        color={Color.DANGER}
        startDecorator={<TrashSimple />}
        onClick={() => setIsConfirmationOpen(true)}
      />

      <Confirmation
        isOpen={isConfirmationOpen}
        color={Color.WARNING}
        title={t('titleRemovePartFinderAttributes', { count: attributes.length })}
        message={t('messageConfirmRemovePartFinderAttributes', {
          count: attributes.length,
          name: attributes[0]?.name,
        })}
        confirmBtnLabel={t('buttonLabelRemove')}
        confirmBtnColor={Color.DANGER}
        onConfirm={onRemove}
        onCancel={() => setIsConfirmationOpen(false)}
      />
    </>
  );
};
